import React from 'react';
import { Container, Typography, Button, Stack } from '@mui/material';
import { Home as HomeIcon, Storefront as StorefrontIcon, SupportAgent as SupportIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import SEO from '../common/SEO';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: { xs: 8, md: 14 }, textAlign: 'center' }}>
      <SEO title="Page Not Found (404)" description="The page you are looking for might have been removed, had its name changed, or is temporarily unavailable." noIndex={true} />
      
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: '6rem', md: '9rem' },
          fontWeight: 900,
          background: 'linear-gradient(135deg, #0E6ADA 0%, #00D2C4 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          lineHeight: 1,
          mb: 2,
        }}
      >
        404
      </Typography>

      <Typography variant="h4" sx={{ fontWeight: 700, color: '#1E293B', mb: 2 }}>
        Oops! Page Not Found
      </Typography>

      <Typography variant="body1" sx={{ color: '#64748B', maxWidth: 500, mx: 'auto', mb: 5, fontSize: '1.05rem', lineHeight: 1.6 }}>
        The link you followed may be broken, or the page may have been moved. Let's get you back on track!
      </Typography>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center" alignItems="center">
        <Button
          variant="contained"
          size="large"
          startIcon={<HomeIcon />}
          onClick={() => navigate('/')}
          sx={{
            bgcolor: '#0E6ADA',
            px: 4,
            py: 1.4,
            borderRadius: 2,
            fontWeight: 700,
            textTransform: 'none',
            fontSize: '1rem',
            boxShadow: '0 4px 14px rgba(14, 106, 218, 0.35)',
            '&:hover': { bgcolor: '#0c57b3' }
          }}
        >
          Go to Home
        </Button>

        <Button
          variant="outlined"
          size="large"
          startIcon={<StorefrontIcon />}
          onClick={() => navigate('/shop')}
          sx={{
            borderColor: '#CBD5E1',
            color: '#1E293B',
            px: 4,
            py: 1.4,
            borderRadius: 2,
            fontWeight: 700,
            textTransform: 'none',
            fontSize: '1rem',
            '&:hover': { borderColor: '#0E6ADA', bgcolor: 'rgba(14, 106, 218, 0.04)' }
          }}
        >
          Browse Software
        </Button>

        <Button
          variant="text"
          size="large"
          startIcon={<SupportIcon />}
          onClick={() => navigate('/contact')}
          sx={{
            color: '#0E6ADA',
            px: 3,
            py: 1.4,
            fontWeight: 700,
            textTransform: 'none',
            fontSize: '1rem',
          }}
        >
          Contact Support
        </Button>
      </Stack>
    </Container>
  );
};

export default NotFoundPage;
